<template>
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    d="M9.53516 2.46484L2.46409 9.53591"
  />
</template>
